import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import { useLoaderData, useLocation } from "react-router-dom-v5-compat";
import { useCompany } from "../Shared/components/CompanyProvider/CompanyProvider";
import { useLogging } from "../Shared/hooks/useLogging/useLogging";
export const useThankYou = () => {
    var _a, _b, _c;
    const { thankYouMarkdown } = useLoaderData();
    const location = useLocation();
    const { createKlaviyoEvent, logReactPixel, logReactPixelPageView, gaEvent, gaPageView } = useLogging();
    const { culture: { currency }, } = useCompany();
    const orderInfo = location.state.orderInfo;
    const giftCard = location.state.giftCard;
    const isGiftCardOrder = giftCard !== undefined;
    const meals = (_a = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.days) === null || _a === void 0 ? void 0 : _a.flatMap((day) => day.meal_dates.flatMap((mealDate) => mealDate.meal_list.flatMap((meal) => {
        return {
            id: meal.ProgramMealId,
            quantity: meal.quantity,
            item_price: meal.meal_cost,
        };
    })));
    const total = (_c = (_b = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.total) !== null && _b !== void 0 ? _b : giftCard === null || giftCard === void 0 ? void 0 : giftCard.paymentAmount) !== null && _c !== void 0 ? _c : 0;
    useEffect(() => {
        logReactPixelPageView();
        if (isGiftCardOrder) {
            logReactPixel("Purchase", {
                currency: currency,
                value: total,
                content_type: "gift card",
            });
        }
        else {
            logReactPixel(orderInfo.IsSubscription ? "Subscription" : "Purchase", {
                currency: currency,
                value: total,
                contents: meals,
                content_type: "product",
            });
        }
        createKlaviyoEvent("PageView", {
            SelectedLocation: "ThankYou",
        });
        if (isGiftCardOrder) {
            createKlaviyoEvent("Purchase", {
                CurrencyType: currency,
                Total: total,
            });
        }
        else {
            createKlaviyoEvent(orderInfo.IsSubscription ? "Subscribe" : "Purchase", {
                CurrencyType: currency,
                Total: total,
            });
        }
        if (!isGiftCardOrder) {
            gaEvent(orderInfo.IsSubscription ? "subscribe" : "purchase", {
                currency: currency,
                total: orderInfo.total,
            });
        }
        gaPageView("Thank You", location.pathname);
    }, []);
    return {
        thankYouMarkdown,
    };
};
export const ThankYouLoader = (params) => {
    return axiosPrivate
        .get(`/React/GetThankYouText?sku=${params.sku}`)
        .then((res) => res.data)
        .catch((e) => {
        console.error(e);
    });
};
